import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { rootRoute } from "./__root";

export const invitationRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/invitation",
  component: lazyRouteComponent(
    () =>
      import(
        /* webpackChunkName: "AcceptInvitationPage" */ "@circle-react/components/OnboardingPage/AcceptInvitationPage"
      ),
    "AcceptInvitationPage",
  ),
});
